import { getContextId, PageActionButton, PageActions, PageActionsMenu, PageHeader, PageTitle } from '@tlx/astro-shared';
import { AddIcon, HistoryIcon, PopupMenuItemButton, TipsIcon } from '@tlx/atlas';
import { FormattedMessage } from 'react-intl';
import { AUTH_LEVEL_DEPARTMENT, useTskContext } from '@Hooks/useTskContext.ts';

export function EmployeeOverviewHeader(props: {
    pageTitle: string;
    runEmployeeOverviewTour: () => void;
    width: number;
}) {
    const { authLevelEmployeeOrWage, showOldPage } = useTskContext();
    const showNewEmployeeButton = authLevelEmployeeOrWage >= AUTH_LEVEL_DEPARTMENT;

    return (
        <PageHeader>
            <PageTitle>{props.pageTitle}</PageTitle>
            <PageActions>
                {showNewEmployeeButton ? (
                    <PageActionButton
                        id="create-employee"
                        variant={'primary'}
                        className="atl-whitespace-nowrap"
                        data-testid="create-employee"
                        onClick={() =>
                            window.open(
                                '/execute/employeeMenu?employeeId=0&isExternal=false&allowLogin=true&contextId=' +
                                    getContextId(),
                            )
                        }
                    >
                        <FormattedMessage id="heading_new_employee" />
                        <AddIcon />
                    </PageActionButton>
                ) : null}
                <PageActionsMenu>
                    {showOldPage ? (
                        <PopupMenuItemButton
                            data-testid={'old-page-button'}
                            onClick={() => {
                                window.location.assign('/execute/listEmployees?contextId=' + getContextId());
                            }}
                        >
                            <HistoryIcon />
                            <FormattedMessage id={'text_change_to_old_page'} />
                        </PopupMenuItemButton>
                    ) : null}
                    <PopupMenuItemButton data-testid={'what-is-new'} onClick={() => props.runEmployeeOverviewTour()}>
                        <TipsIcon />
                        <FormattedMessage id={'text_what_is_new'} />
                    </PopupMenuItemButton>
                </PageActionsMenu>
            </PageActions>
        </PageHeader>
    );
}
